import { fundingNavigationManifest } from '../generated/navigation.js';
export function exchangeTarget(event) {
    return fundingNavigationManifest.exchange_checkout.events[event];
}
export function exchangeBack(screen, submitted) {
    if (submitted)
        return 'methods';
    return fundingNavigationManifest.exchange_checkout.screens[screen].back;
}
/** Browser completion is not authorization; only the backend/provider status is. */
export function exchangeStatusScreen(status) {
    if (status === 'connected')
        return exchangeTarget('authorization_complete');
    if (status === 'action_required')
        return exchangeTarget('withdrawal_action_required');
    if (status === 'pending' || status === 'expired')
        return 'exchange_auth';
    if (status === 'rejected')
        return 'exchanges';
    return 'status';
}
